import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Agency, queryFilter } from '@/modules/Agency/interfaces/agency'
import { showErrors } from '@/utils/snack'

import AgencyDialog from './agency-dialog'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { getAgencies } from '@/modules/Agency/gql/agency.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppTextField,
    AppRefresh
  }
})
export default class AgenciesList extends mixins(AgencyDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Settings'
    },
    {
      text: 'Agencies'
    }
  ]
  searchVal = ''
  agencies: Agency[] = []
  ifRelatedList = false

  orderBy: {
    [key: string]: string
  } = {
    name: 'NAME',
    phone: 'PHONE',
    email: 'EMAIL',
    contact: 'CONTACT',
    id: 'ID'
  }

  tableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name_default' },
      sortable: true,
      resizable: true
    }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  get filter (): queryFilter {
    return {
      name: this.searchVal ? this.searchVal : null
    }
  }

  mounted () {
    this.getAgencies()
  }

  async getAgencies () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAgencies,
        variables: {
          filter: this.filter,
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.tableOptions.loading = false
      this.agencies = result.data.getAgencies.agencies
      this.tableOptions.tablePage.total = result.data.getAgencies.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  refreshList () {
    this.searchVal = ''
    this.getAgencies()
  }

  async deleteAgencyConfirm () {
    await this.deleteAgencyPost()
    this.getAgencies()
  }

  routeToDetail (item: any) {
    return {
      name: 'AgencyDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getAgencies()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getAgencies()
  }
}
